import { useEffect } from 'react';

import { initializeGTM } from './utils/initialize-gtm';
import type { GTMEvent } from './use-google-tag-manager.type';

export const useGoogleTagManager = () => {
  useEffect(() => {
    const gtmId: string = import.meta.env.VITE_GTM_ID;

    if (!gtmId) {
      return;
    }

    if (window.dataLayer && document.querySelector(`script[src*="gtm.js?id=${gtmId}"]`)) {
      return;
    }

    initializeGTM(gtmId);
  }, []);

  const pushEvent = (event: GTMEvent) => {
    if (window.dataLayer) {
      window.dataLayer.push(event);
    } else {
      console.warn('GTM dataLayer not available. Event not sent:', event);
    }
  };

  const pushPageView = (page_title?: string, page_location?: string) => {
    pushEvent({
      event: 'page_view',
      page_title,
      page_location: page_location ?? window.location.href,
    });
  };

  return {
    pushEvent,
    pushPageView,
  };
};
